import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6c13b725cd6baee01e7b0eadb4e4e66cb from "./generated-1d0ecaae-14ba-4c5b-abab-bc94d90d14a5.json";

import af7d2e4d20a8e194c6f64ed5d9d04250bb from "./generated-6a5cb290-0b61-48e2-9bc3-777084338392.json";

import ab72ee07dc9794c6479d9de43d295cdd5b from "./generated-2bf8af88-8cf1-4c05-8169-5275f2097b80.json";

import affde6072a35be5881eaeeef03e5ef78bb from "./generated-c6a0f66e-70af-4458-9fe1-6da2a1c48323.json";

import a6283ed92cea34e330980242042edb1b7b from "./generated-7b5db73d-f2a9-40a8-8b00-f71ea504f376.json";

import a7b80734ea4019c51170f5937ae11a6abb from "./generated-073b5c17-3032-4f29-86b5-a82cf229c9da.json";

import a7d2a6caa7165c14e2b97b22e2ac1e125b from "./generated-55f23cc4-b7b5-4fc8-a104-f46a68dae5ae.json";

import accd5a38df37f9c73671348ea71b0a0e7b from "./generated-52289cfa-296a-4b46-b125-9dcec9ff9b4b.json";

import a97c21f073b94ea7c9f088cd08ff87f61b from "./generated-644b4dd2-c1b2-4bb2-a70f-c7d22161add8.json";

import a72f1674cc277380a09b50cdb3d1cd355b from "./generated-fd390d49-98e2-4f25-a4b1-0bfa6d118630.json";

import aafe8ad21b438640278223825f8eae0beb from "./generated-d42906a4-11a7-486e-8a87-e20381cda554.json";

import a32c7931df791a2480dd6595c0c181edfb from "./generated-49f94208-277d-45b8-b172-45c975abf08d.json";

import a222ea43343f0690218128be9c4361059b from "./generated-88ad0a29-6c21-45c7-8e6a-416647698f18.json";

import acd7d5d341dcd199ee2e3ee6f8900530cb from "./generated-ce645c2a-23ae-4c59-b923-a31a083c4a97.json";

import a70948b99d0b2c62dc015ec8e3c9bb2bab from "./generated-1d6cac31-a38f-458c-8f4b-3ad68cfbb5cb.json";

import a80b2a676faba6c126301c130c2ad99b8b from "./generated-850b3eee-475b-4cff-baa6-1ba9448b67d4.json";

import ab6fb9a62e55ebae16088464c4704045db from "./generated-cb18c3b0-1444-403a-9e41-2bc8fbf9e6e4.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6c13b725cd6baee01e7b0eadb4e4e66cb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(af7d2e4d20a8e194c6f64ed5d9d04250bb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(ab72ee07dc9794c6479d9de43d295cdd5b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(affde6072a35be5881eaeeef03e5ef78bb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a6283ed92cea34e330980242042edb1b7b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a7b80734ea4019c51170f5937ae11a6abb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a7d2a6caa7165c14e2b97b22e2ac1e125b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(accd5a38df37f9c73671348ea71b0a0e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a97c21f073b94ea7c9f088cd08ff87f61b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a72f1674cc277380a09b50cdb3d1cd355b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(aafe8ad21b438640278223825f8eae0beb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a32c7931df791a2480dd6595c0c181edfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a97c21f073b94ea7c9f088cd08ff87f61b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a222ea43343f0690218128be9c4361059b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(acd7d5d341dcd199ee2e3ee6f8900530cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a97c21f073b94ea7c9f088cd08ff87f61b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a70948b99d0b2c62dc015ec8e3c9bb2bab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a80b2a676faba6c126301c130c2ad99b8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ab6fb9a62e55ebae16088464c4704045db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a70948b99d0b2c62dc015ec8e3c9bb2bab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */